import { nullable, string, struct } from 'io-ts/Decoder';

import { Scopes } from '../../Scopes';

export const Request = struct({
	firstName: string,
	lastName: string,
	email: string,
	employmentStartAt: nullable(string),
	employmentEndAt: nullable(string),
	cohort: nullable(string),
	scopes: Scopes,
});
